import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
// tslint:disable-next-line:import-blacklist
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { NGaugeService } from './shared/ngauge.service';
import { UserService } from './user.service';
import { AuthService } from './shared/auth.service';
import { map, switchMap } from 'rxjs/operators';

interface BroadcastEvent {
  key: any;
  data?: any;
}
@Injectable()
export class GroupService {
  defaultProperty: any;
  grcForm: any;
  currentPage: any;
  private _eventBus: Subject<BroadcastEvent>;
  salesCalSub = new BehaviorSubject<any>(null);
  salesCal$ = this.salesCalSub.asObservable();

  constructor(private httpClient: HttpClient,
    private userService: UserService,
    private authservice :AuthService,
    private ngaugeService: NGaugeService, private authService: AuthService) {
    this._eventBus = new Subject<BroadcastEvent>();
  }

  publishSalesCalendarProperty(salesActivity) {
    this.salesCalSub.next(salesActivity);
  }

  broadcast(key: any, data?: any) {
    this._eventBus.next({ key, data });
  }

  on<T>(key: any): Observable<T> {
    return this._eventBus.asObservable()
      .filter(event => event.key === key)
      .map(event => <T>event.data);
  }

  createGroup(groupDetail) {
    return this.httpClient.post(this.ngaugeService.getMeldURL('ADDGROUP'), { 'groupdetail': groupDetail, 'SID': this.authService.getSID() });
  }

  updateGroup(groupDetail) {
    return this.httpClient.put(this.ngaugeService.getMeldURL('UPDATEGROUP'), { 'groupdetail': groupDetail, 'SID': this.authService.getSID() });
  }

  setGrc(value) {
    this.currentPage = value;
  }

  getGrc() {
    return this.currentPage;
  }

  createGroupsalesActivity(groupsalesActivityDetail) {
    return this.httpClient.post(this.ngaugeService.getMeldURL('ADDGROUPSALESACTIVITY'),
      { 'salesactivitydetail': groupsalesActivityDetail , 'SID':this.authService.getSID()});
  }

  updateGroupsalesDate(id, data) {
    data['id'] = id;
    return this.httpClient.put(this.ngaugeService.getMeldURL('GROUP_INFO') + '/' + id, data);
  }

  updateGroupInfo(groupInfo) {
    return this.httpClient.put(this.ngaugeService.getMeldURL('UPDATEGROUP'), { 'groupdetail': groupInfo,'SID': this.authService.getSID() });
  }

  getGroupSalesActivity(groupId) {
    const filter = '?groupId=' + groupId;
    return this.httpClient.get(this.ngaugeService.getMeldURL('GETGROUPSALESACTIVITY') + filter);
  }

  getAllGroupSalesActivity(accountId, groupId) {
    const whereFilter = '"where": {"and": [{"groupId":' + groupId + '},{"accountId": ' + accountId + '}]}';
    const columnFilter = '"fields": ["typeOfSalesActivity", "id","SID"]';
    const filter = '{' + whereFilter + ',' + columnFilter + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('Group_SALES_ACTIVITY'), params);
  }

  getGroupByAccountId(accountId) {
    const whereCondition = '"where": {"accountId":' + accountId + '}';
    const filter = '{' + whereCondition + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GROUP_INFO'), params);
  }

  setGrcForm(form) {
    this.grcForm = form;
  }

  getGrcForm() {
    return this.grcForm;
  }

  getSalesEvents(userProperty, propertyType) {
    // if (propertyType === false) {
    //   const params = { 'property': userProperty };
    //   return this.httpClient.post(this.ngaugeService.getMeldURL('GET_SALES_INFO'), params);
    // } else {
      const whereCondition = '"where": {"property": "' + userProperty + '"}';
      const fields = '"fields": ["startDate","endDate","hotDate", "noGroupBooking", "id"]';
      const filter = '{' + whereCondition + ',' + fields + '}';
      const params = { params: this.ngaugeService.getHttpParams(filter) };
      return this.httpClient.get(this.ngaugeService.getMeldURL('GETSALESDATA'), params);
    // }
  }

  getScheduledEvent(id, propertyType, userProperty) {
    // if (propertyType === false) {
    //   const params = { 'property': userProperty, id };
    //   return this.httpClient.post(this.ngaugeService.getMeldURL('GET_SALES_INFO_ID'), params);
    // } else {
      const whereCondition = '"where": {"id": ' + id + ',"property":"'+ userProperty+'"}';
      const filter = '{' + whereCondition + '}';
      const params = { params: this.ngaugeService.getHttpParams(filter) };
      return this.httpClient.get(this.ngaugeService.getMeldURL('SALES_CALENDARS'), params);
    // }
  }

  getSalesEventsById(id) {
    const whereFilter = '"where":{"id":' + id + '}';
    const filter = '{' + whereFilter + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GETSALESDATA'), params);
  }

  getGrcGroups(date, totaldays, property) {
    totaldays -= 1;
    let httpParams = new HttpParams();
    httpParams = httpParams.append('property', property).append('date', date).append('days', totaldays).append('SID',this.authService.getSID())
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_GROUP_DURATION_INFO'), { params: httpParams });
  }

  createGroupSchedule(salesPlan, propertyType) {
    let params = new HttpParams();
      params=params.append('roomratedetail',JSON.stringify(salesPlan))
      params=params.append('SID',this.authservice.getSID())
    // if (!propertyType) {
    //   return this.httpClient.post(this.ngaugeService.getMeldURL('CREATE_PROPERTY_SALES_CALENDAR'), params);
    // }
    return this.httpClient.post(this.ngaugeService.getMeldURL('CREATESALES'), params);
  }

  updateGroupSchedule(salesPlan, propertyType) {
    // if (!propertyType) {
    //   return this.httpClient.post(this.ngaugeService.getMeldURL('UPDATE_PROPERTY_SALES_CALENDAR'), { 'roomratedetail': salesPlan });
    // }
    return this.httpClient.put(this.ngaugeService.getMeldURL('UPDATESALES'), { 'roomratedetail': salesPlan , 'SID': this.authService.getSID() });
  }

  getGroupById(groupId, SID) {
    const whereCondition = '"where": {"id": ' + groupId + ', "SID": ' + SID + '}';
    const filter = '{' + whereCondition + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GROUP_INFO'), params);
  }

  getSalesEventsDetails() {
    return this.httpClient.get(this.ngaugeService.getMeldURL('SALES_CALENDARS'));
  }

  getSalesEventsDetailsByDate(date) {
    return this.httpClient.get(this.ngaugeService.getMeldURL('SALES_CALENDARS') +
      '?filter[where][startDate][between][0]=' + date +
      '&filter[where][endDate][between][1]=' + date);
  }

  getActivity(startDate, endDate, property): Observable<any> {
    return this.getpropertysid(property).pipe(
      switchMap((sid) => {
        let httpParams = new HttpParams()
          .append('startDate', startDate)
          .append('endDate', endDate)
          .append('property', property)
          .append('SID', sid);

        return this.httpClient.get(this.ngaugeService.getMeldURL('SALES_CALENDARS_ACTIVITIES'), { params: httpParams });
      })
    );
  }

  getMasterDropDowns() {
    const property = this.userService.getLoggedInUserProperty();
    let httpParams = new HttpParams();
    httpParams = httpParams.append('property', property).append('SID',this.authService.getSID())
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_MASTER_DATA'), { params: httpParams });
  }

  getSalesEventsByColumns(property) {
    const whereFilter = '"where": {"property": "' + property + '"}';
    const columnFilter = '"fields": ["startDate", "endDate", "cta", "id", "property","SID"]';
    const filter = '{' + columnFilter + ',' + whereFilter + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('SALES_CALENDARS'), params);
  }

  getGroupTraceDetails(groupId) {
    const whereCondition = '"where":{"and":[{"groupId": ' + groupId + '},{"SID":'+this.authService.getSID()+'}]}';
    const filter = '{' + whereCondition + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('Group_SALES_ACTIVITY'), params);
  }

  getGroupSalesActivityById(salesActivityId) {
    const whereCondition = '"where": {"id": ' + salesActivityId + '}';
    const filter = '{' + whereCondition + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('Group_SALES_ACTIVITY'), params);
  }

  getNotes(accountId, groupId) {
    const whereCondition = '"where": {"and": [{"accountId":' + accountId + '},{"groupId":' + groupId + '}]}';
    const columnFilter = '"fields": ["contract", "reservation", "salesOffice", "houseKeeping",' +
      ' "frontDesk", "engineering", "bellman", "security", "foodAndBeverage", "other", "id", ' +
      '"accountId", "groupId","SID"]';
    const filter = '{' + whereCondition + ',' + columnFilter + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GROUP_NOTES'), params);
  }

  updateGroupSalesActivity(groupTraceDetail) {
    return this.httpClient.put(
      this.ngaugeService.getMeldURL('UPDATEGROUPSALESACTIVITY'),
      { 'salesactivitydetail': groupTraceDetail,'SID':this.authService.getSID() });
  }

  createGroupSalesActivity(groupTraceDetail) {
    return this.httpClient.post(
      this.ngaugeService.getMeldURL('ADDGROUPSALESACTIVITY'),
      { 'salesactivitydetail': groupTraceDetail, 'SID':this.authService.getSID() });
  }

  createNotes(notes) {
    return this.httpClient.post(this.ngaugeService.getMeldURL('CREATE_GROUP_NOTES'), { 'notedetail': notes ,'SID':this.authService.getSID() });
  }

  updateNotes(notes) {
    return this.httpClient.put(this.ngaugeService.getMeldURL('UPDATE_GROUP_NOTES'), { 'notedetail': notes,'SID':this.authService.getSID() });
  }

  getNameAndIdFilter() {
    const columnFilter = '"fields": ["name", "id","SID"]';
    return '{' + columnFilter + '}';
  }

  getGroupCancellationPolicies() {
    const filter = this.getNameAndIdFilter();
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_GROUP_CANCELLATION_POLICIES'), params);
  }

  getGroupRoomTypes() {
    const whereFilter = '"where": {"property": "' + this.userService.getLoggedInUserProperty() + '"}';
    const columnFilter = '"fields": ["name", "id","SID"]';
    const filter = '{' + whereFilter + ',' + columnFilter + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_GROUP_ROOM_TYPES'), params);
  }

  getCompPolicyTypes() {
    const filter = this.getNameAndIdFilter();
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_GROUP_COMPPOLICY'), params);
  }

  getBaggageTypes() {
    const filter = this.getNameAndIdFilter();
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_GROUP_BAGGAGE_TYPES'), params);
  }

  getBillingTypes() {
    const filter = this.getNameAndIdFilter();
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_GROUP_BILLING_INSTRUCTIONS'), params);
  }

  getGroupTypesList() {
    const filter = this.getNameAndIdFilter();
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_ACCOUNT_GROUP_TYPES_LIST'), params);
  }

  getGroupStatusList() {
    const filter = this.getNameAndIdFilter();
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_ACCOUNT_GROUP_STATUS_LIST'), params);
  }

  getGroupFinalStatusList() {
    const filter = this.getNameAndIdFilter();
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_ACCOUNT_GROUP_FINALSTATUS_LIST'), params);
  }

  getGroupReservationList() {
    const filter = this.getNameAndIdFilter();
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_ACCOUNT_GROUP_RESERVATIONS_LIST'), params);
  }

  getGroupGuaranteeList() {
    const filter = this.getNameAndIdFilter();
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_ACCOUNT_GROUP_GUARANTEE_LIST'), params);
  }

  getGroupParkingList() {
    const columnFilter = '"fields": ["name", "id", "rate","SID"]';
    const filter = '{' + columnFilter + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_ACCOUNT_GROUP_PARKING_LIST'), params);
  }

  getGroupStayTypesList() {
    const filter = this.getNameAndIdFilter();
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_ACCOUNT_GROUP_STAYTYPES_LIST'), params);
  }

  getCuttOffDates() {
    const filter = '{"fields": ["type", "id", "duration", "name", "description"]}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_CUTT_OFF_DATES'), params);
  }

  getContractTemplate() {
    const whereCondition = '"where": {"or": [{"type":"Group_proposal"}, {"type": "Group_proposal_dropdown_template"}]}';
    const fields = '"fields": ["title", "description", "id", "type"]';
    const filter = '{' + whereCondition + ',' + fields + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_CONTRACT_TEMPLATES'), params);
  }

  getAgreementTemplate() {
    const whereCondition = '"where": {"type": "Group_and_Funtion_Agreement_Template"}';
    const fields = '"fields": ["title", "description", "id", "type"]';
    const filter = '{' + whereCondition + ',' + fields + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_CONTRACT_TEMPLATES'), params);
  }

  getRoomSchedule(roomScheduleId) {
    const whereCondition = '"where": {"id":' + roomScheduleId + '}';
    const fields = '"fields": ["id", "roomSchedule", "depositDue", "deposit"]';
    const filter = '{' + whereCondition + ',' + fields + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_FUNCTION'), params);
  }

  getTax() {
    const fields = '"fields": ["id", "tax1", "tax1type", "tax1description", "tax4", "tax4type", "tax4description"]';
    const filter = '{' + fields + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_GROUP_ROOM_TYPES'), params);
  }

  getDocStyle() {
    return {
      header: { fontSize: 13, bold: true },
      subheader: { fontSize: 11, bold: true },
      detail: { fontSize: 8, bold: false },
      tableExample: { margin: [0, 5, 0, 0], },
      tableHeader: { bold: true, fontSize: 8, color: 'black', fillColor: '#dedede' }
    };
  }

  getpropertysid(property: any): Observable<string> {
    const whereCondition = '"where": {"name": "' + property + '"}';
    const fields = '"fields":["id", "SID", "name"]';
    const filter = '{' + whereCondition + ',' + fields + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };

    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_PROPERTY_LIST'), params)
      .pipe(
        map((response: any) => {
          if (response.length > 0) {
            return response[0].SID.toString(); // Convert SID to string
          } else {
            return null;
          }
        })
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/group.service.ts